import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React from 'react';
import { ListItem } from '../../../../../../../design-system';
import { CommandItemProps } from '../types/commands';

export const CommandItem: React.FC<CommandItemProps> = ({
  label,
  description,
  isDisabled,
  onClick,
  dialog,
}: CommandItemProps) => (
  <ListItem>
    <Grid container spacing={3}>
      <Grid item sm={12} md={8} lg={10}>
        <Box my={1}>
          <Typography>{label}</Typography>
          <Typography variant="body2" color="textSecondary">
            {description}
          </Typography>
        </Box>
      </Grid>
      <Grid item sm={12} md={4} lg={2}>
        <Box display="flex" alignItems="center" justifyContent="center" height="100%">
          <Button
            onClick={onClick}
            disabled={isDisabled}
            variant="outlined"
            fullWidth
            aria-label={`Send ${label} command`}
          >
            Send...
          </Button>
        </Box>
      </Grid>
    </Grid>
    {dialog}
  </ListItem>
);
